<script setup lang="ts">
    import $ from 'jquery'
    import { computed, watch, nextTick } from 'vue'

    import { KendoChart } from '@Kendo/Components/KendoChart'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        propOpened: boolean
        propTitle?: string
        propChart?: KendoChart | null
    }>()

    const emit = defineEmits<{
        (e: 'close-dialog'): void
    }>()

    // ---------------- computed ----------------

    const opened = computed(() => props.propOpened)
    const chart = computed(() => props.propChart ?? null)
    const title = computed(() => props.propTitle ?? '')

    // ---------------- watchers ----------------

    watch(opened, async (val) =>
    {
        if (!chart.value) return

        if (val === true)
        {
            await nextTick()

            $('#FullScreenChart').kendoChart(
                chart.value.GetOptions().Get()
            )

            chart.value.IsFullScreen = true
        }
        else
        {
            chart.value.IsFullScreen = false
        }
    })

    // ---------------- actions ----------------

    function close()
    {
        emit('close-dialog')
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable" style="max-width: 96%;">
                <div class="modal-content" style="height: calc(100vh - 5px);">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body" style="height: 100%;">
                        <div id="FullScreenChart" style="height: 100%;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>